import { useTranslation } from "react-i18next";
import cls from "classnames";
import { ReactComponent as StopIcon } from "logic/src/components/icons/stop.svg";

import styles from "./index.module.scss";

const Stop: React.FC<{
  onStop: () => void;
  visible: boolean;
  disabled: boolean;
}> = ({ onStop, visible, disabled }) => {
  const { t } = useTranslation();

  return (
    <div
      className={styles.mask}
      style={{ display: visible ? "block" : "none" }}
    >
      <div
        className={cls(styles.container, disabled && styles.disabled)}
        onClick={() => !disabled && onStop?.()}
      >
        <StopIcon className={styles.left} />
        {/* 停止生成 */}
        <div className={styles.right}>{t("sensechat-77")}</div>
      </div>
    </div>
  );
};

export default Stop;
